import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

export function CounterOfferDialog({
  open,
  amount,
  notes,
  error,
  isSaving,
  onOpenChange,
  onAmountChange,
  onNotesChange,
  onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Log vendor counter</DialogTitle>
          <DialogDescription>
            Record the vendor&apos;s actual counteroffer before updating negotiation guidance.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="vendor-counter-amount">Counter amount</Label>
            <div className="relative">
              <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-y-0 left-3 flex items-center font-semibold text-muted-foreground"
              >
                £
              </span>
              <Input
                id="vendor-counter-amount"
                value={amount}
                inputMode="decimal"
                autoFocus
                aria-invalid={Boolean(error)}
                aria-describedby={error ? 'vendor-counter-error' : undefined}
                className="pl-7"
                onChange={(event) => onAmountChange?.(event.target.value)}
              />
            </div>
            {error ? (
              <p id="vendor-counter-error" className="text-sm font-medium text-destructive">
                {error}
              </p>
            ) : null}
          </div>

          <div className="space-y-2">
            <Label htmlFor="vendor-counter-notes">Counter notes</Label>
            <Textarea
              id="vendor-counter-notes"
              value={notes}
              rows={3}
              placeholder="Add agent or vendor context..."
              className="resize-none"
              onChange={(event) => onNotesChange?.(event.target.value)}
            />
          </div>
        </div>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange?.(false)}>
            Cancel
          </Button>
          <Button type="button" disabled={isSaving} onClick={onSave}>
            {isSaving ? 'Saving...' : 'Save Counter'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
